export default __webpack_public_path__ + "3216f074de9c07b4ef87edf524c9641a.png";